import axios from 'axios';

// 创建 axios 实例
const request = axios.create({
  // baseURL: 'http://43.143.125.23:9660', // 设置基础请求路径
  // baseURL: process.env.NODE_ENV === 'development' ? '/minio-api' : 'http://43.143.125.23:9660',
  baseURL: '', // 设置基础请求路径
  timeout: 60 * 1000 * 30, // 增加超时时间到30秒，因为下载文件可能需要更长时间
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器
request.interceptors.request.use(
  async (config) => {
    // 如果请求中包含自定义headers（用于minio认证），则合并headers
    if (config.headers) {
      config.headers = {
        ...config.headers,
      };
    }
    return config;
  },
  (error) => {
    // 请求错误处理
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  async (response) => {
    const {
      data,
      status,
      config
    } = response;
    
    if (config.responseType === 'blob') {
      return data;
    }
    
    if (status === 200) {
      var resDeRes = data;
      
      if (typeof resDeRes === 'string') {
        return resDeRes;
      }
      
      if (resDeRes.code == 200) {
        return resDeRes;
      } else {
        if (resDeRes.code == 980) {
         
        }
        return Promise.reject(resDeRes.msg);
      }
    } else {
      return Promise.reject(resDeRes.msg);
    }
  },
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          alert('Unauthorized. Please log in again.');
          break;
        case 404:
          alert('API not found');
          break;
        default:
          alert(`Error: ${error.response.status}`);
      }
    }
    return Promise.reject(error);
  }
);


export default request;


// WEBPACK FOOTER //
// ./src/utils/api/minioRequest.js